import { render } from "./CustomerProfileDialog.vue?vue&type=template&id=4daa0b3c&scoped=true"
import script from "./CustomerProfileDialog.vue?vue&type=script&lang=js"
export * from "./CustomerProfileDialog.vue?vue&type=script&lang=js"

import "./CustomerProfileDialog.vue?vue&type=style&index=0&id=4daa0b3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4daa0b3c"]])

export default __exports__